import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon, SearchIcon } from "@heroicons/react/outline";

export default function SlideOver({
  slideOver,
  title,
  subtitle,
  slideOverHandler,
  search,
  children,
}: {
  slideOver: boolean;
  title: string;
  subtitle: string;
  slideOverHandler: () => void;
  children: JSX.Element;
  search?: boolean;
}) {
  return (
    <Transition.Root show={slideOver} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 overflow-hidden z-10"
        onClose={slideOverHandler}
      >
        <div className="absolute inset-0 overflow-hidden">
          <Dialog.Overlay className="absolute inset-0" />

          <div className="fixed top-10 inset-y-0 right-0 pl-10 max-w-full flex">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <div className="w-screen max-w-md">
                <div className="h-full flex flex-col py-6 bg-white shadow-xl overflow-y-scroll">
                  <div className="px-4 sm:px-6 bg-neutralColor-lighter">
                    <div className="flex items-center justify-between">
                      <Dialog.Title className="text-lg font-bold text-neutralColor-dark">
                        {title}
                      </Dialog.Title>
                      <div className="ml-3 h-7 flex items-center">
                        <XIcon
                          className="h-6 w-6 text-neutralColor-normal cursor-pointer"
                          aria-hidden="true"
                          onClick={slideOverHandler}
                        />
                      </div>
                    </div>
                    <p className="text-sm mb-5">{subtitle}</p>
                    {search && (
                      <div className="flex items-center justify-between bg-white border-2 border-neutralColor-light rounded-md mr-4 pr-2 w-full mb-6">
                        <input
                          type="text"
                          placeholder="Search..."
                          className="py-2 px-6 text-sm focus:outline-none"
                        />
                        <SearchIcon className="h-5 w-5 text-neutralColor-normal mr-5" />
                      </div>
                    )}
                  </div>
                  <div className="relative flex-1">
                    {/* Replace with your content */}
                    {children}
                    {/* /End replace */}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
